import request from "../utils/request";

// 获取页面状态
export function GetStatus() {
    return request({
        url: '/Api/public/GetOpen.ashx',
        params: {
            code: '230109'
        }
    })
}

// 获取用户信息
export function GetMyInfo() {
    return request({
        skipError:true,
        url: '/Api/2023/0109/Load.ashx'
    })
}

// 发送手机验证码
export function SendCode(phone,vkey){
    return request({
        method:'post',
        data:{
            phone, appid:'230109', vkey
        },
        url:'/Api/2023/0109/Send.ashx'
    })
}

// 手机登录
export function PhoneLogin(phone,code){
    return request({
        method:'post',
        data:{phone,code},
        url:'/Api/2023/0109/Login.ashx'
    })
}

// 手机登录直接助力
export function LoginHelp(phone,code,helpcode){
    return request({
        method:'post',
        data:{phone,code,helpcode},
        url:'/Api/2023/0109/Login.ashx'
    })
}

// 绑定发送验证码
export function GetVCode(){
    return request({
        skipLoading:true,
        url:'/Api/public/GetVcode.ashx',
        params:{
            code:'230109'
        }
    })
}

// 校验验证码
export function CheckVcode(Vcode){
    return request({
        method:'post',
        skipError:true,
        skipLoading:true,
        url:'/Api/public/CheckVcode.ashx',
        data:{
            code:'230109',
            Vcode
        }
    })
}

// 绑定确认
export function ConfirmBind(){
    return request({
        url:'/Api/2023/0109/BindGame.ashx'
    })
}

// 旅行见闻
export function GetSpeakers(){
    return request({
        url:'/Api/2023/0109/GetSpecialLogs.ashx'
    })
}

// 投掷筛子
export function GetPointer(){
    return request({
        url:'/Api/2023/0109/Run.ashx'
    })
}

// 获取绑定列表
export function GetBinds(){
    return request({
        skipError:true,
        url:'/Api/2023/0109/GetBindList.ashx'
    })
}

// 获取助力列表
export function GetHelpers(){
    return request({
        url:'/Api/2023/0109/GetHelpList.ashx'
    })
}

// 领取助力筛子数
export function GetHelpReward(type){
    return request({
        method:'post',
        url:'/Api/2023/0109/GetTouZi.ashx',
        data:{type}
    })
}

// 兑换筛子
export function ExChangePointer(code){
    return request({
        method:'post',
        url:'/Api/2023/0109/Exchange.ashx',
        data:{code}
    })
}

// 领奖记录
export function GetRewardsList(){
    return request({
        url:'/Api/2023/0109/GetRewardLogs.ashx'
    })
}

// 寻宝记录（未领取的道具列表 + 激活的角色列表 + 已领取的伙伴赠礼）
export function GetRunRewards(){
    return request({
        url:'/Api/2023/0109/GetRunLogs.ashx'
    })
}

// 实物登记记录
export function GetAddress(){
    return request({
        url:'/Api/2023/0109/GetAddress.ashx'
    })
}

// 实物地址登记
export function SetAddress(name,phone,addr,gameid){
    return request({
        method:'post',
        url:'/Api/2023/0109/SetAddress.ashx',
        data:{name,phone,addr,gameid}
    })
}

// 领取奖励
export function AcceptRewards(type){
    return request({
        method:'post',
        url:'/Api/2023/0109/GetReward.ashx',
        data:{type}
    })
}

// 点击助力
export function ClickHelp(helpcode){
    return request({
        method:'post',
        url:'/Api/2023/0109/Help.ashx',
        data:{helpcode}
    })
}

// 领取宝箱
export function GetBagReward(){
    return request({
        url:'/Api/2023/0109/GetBag.ashx'
    })
}